import { createFeatureSelector } from '@ngrx/store';
import { ModalState } from './modal.state';


export const MODAL_NAME = 'modal_view-installer-profile-enhanced';

export const modalState = createFeatureSelector<ModalState>(MODAL_NAME);
